/**
 * Created by pajicv on 9/28/18.
 */
import React from 'react';
import { connect } from 'react-redux';
import MemberToolbar from '../common/MemberToolbar';
import MemberFooter from '../common/MemberFooter';
import { Typography, withStyles, Avatar, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { MANAGER_ROLE, CO_MANAGER_ROLE, WORKER_ROLE } from '../../utils/constants';
import { MAIN_COLOR } from '../../firebase-config';
import { toast } from 'react-toastify';

const styles = theme => ({
    pageContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    upperContainer: {
        flexGrow: 1,
        textAlign: 'left'
    },
    lowerContainer: {
        flexGrow: 1
    },
    invitedList: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center'
    },
    invitedListItem: {
        margin: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: 520
    },
    avatar: {
        color: '#fff',
        backgroundColor: MAIN_COLOR,
        width: 40,
        height: 40,
        marginRight: 10
    },
    innerContainer: {
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        width: '100%'
    },
    innerContainer2: {
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        padding: 25,
    },
});

class ProjectMembers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            role: 'worker',
            name: '',
            email: '',
            members: {}
        }
    }

    componentDidMount() {
        if (this.props.members) {
            this.setState({
                members: this.props.members
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.members !== this.props.members) {
            this.setState({ members: this.props.members })
        }
    }

    handleTextFieldChange = (field, value) => {
        this.setState({ [field]: value });
    };

    handleInviteClick = (role, name, email) => {
        const { onInviteMember, members } = this.props;
        if (members[window.btoa(email)]) {
            toast.error("Team Mitglied bereits vorhanden!", {
                position: "top-center",
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                autoClose: 2000,
            });
        } else {
            onInviteMember({ role, name, email })
            this.setState({
                role: 'worker',
                name: '',
                email: '',
            })
        }
    }

    render() {
        const { classes, onDeleteMember, auth } = this.props;
        const { role, name, email, members } = this.state;
        return (
            <div className={classes.innerContainer}>
                <div className={classes.innerContainer2}>
                    <MemberToolbar
                        role={role}
                        name={name}
                        email={email}
                        onRoleChange={(e) => this.handleTextFieldChange('role', e.target.value)}
                        onNameChange={(e) => this.handleTextFieldChange('name', e.target.value)}
                        onEmailChange={(e) => this.handleTextFieldChange('email', e.target.value)}
                    />
                    <MemberFooter onInviteClick={(e) => this.handleInviteClick(role, name, email)} />
                </div>
                <div className={classes.innerContainer2}>
                    <div className={classes.invitedListItem}>
                        <Typography variant="title">
                            Eingeladenes Projekt Team
                        </Typography>
                    </div>
                    <div className={classes.invitedList}>
                        {
                            Object.keys(members).map((memberId) => {
                                let memberRole = members[memberId];

                                const memberEmail = window.atob(memberId);
                                const memberName = '';
                                if (!memberRole || typeof memberRole !== 'string' || (memberRole !== MANAGER_ROLE && memberRole !== CO_MANAGER_ROLE && memberRole !== WORKER_ROLE)) {
                                    return null;
                                } else if (members[memberId] === 'worker') {
                                    memberRole = 'Bearbeiter'
                                }
                                return <div className={classes.invitedListItem}>
                                    <Avatar className={classes.avatar}>
                                        {memberName ? memberName.replace(/(\S)\S*\s*/ig, "$1").toUpperCase() :
                                            memberEmail.substring(0, 2).toUpperCase()}
                                    </Avatar>
                                    <Typography style={{ width: 100, textAlign: 'left' }} variant="subheading">{memberRole.charAt(0).toUpperCase() + memberRole.slice(1)}</Typography>
                                    <Typography style={{ width: 300, textAlign: 'left' }} variant="body1">{memberName ? memberName : memberEmail}</Typography>
                                    {(memberEmail !== auth.email) && (
                                        <IconButton onClick={() => onDeleteMember(memberEmail, members[memberId])}>
                                            <DeleteIcon />
                                        </IconButton>
                                    )
                                    }
                                </div>
                            })
                        }
                    </div>

                </div>
            </div >
        );
    }
}

export default withStyles(styles)(
    connect(state => ({ auth: state.firebase.auth }))(ProjectMembers)
);



// WEBPACK FOOTER //
// ./src/components/ProjectSetup/ProjectMembers.js